import React from 'react'
import styled from 'styled-components'

const FlexVertical = ({ className, children }) => {
    return <div className={className}>{children}</div>
}

export default styled(FlexVertical)`
    height: ${props => props.height ? props.height : '100%'};
    display: flex;
    align-items: ${props => props.alignItems ? props.alignItems : 'center'};
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
`
